var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.108,
    height: 13.94,
    viewBox: "0 0 28.108 13.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M6067,1909.061a10,10,0,0,1,8.676,5.027l3.959,6.907a2,2,0,0,0,3.541-.135l2.9-6.1a10,10,0,0,1,9.028-5.7",
    transform: "translate(-6067 -1908.561)",
    fill: "rgba(0,0,0,0.8)",
    stroke: "rgba(255,255,255,0.1)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.0fc1cb06dc0c560c9dcd34666ccd827a.svg";
export { ForwardRef as ReactComponent };